module.exports = __webpack_public_path__ + "img/서브2_키.ed2c1733.svg";